import React from 'react';
import { inject,observer } from 'mobx-react';
import * as mobx from 'mobx';
import { getAntd,getEcCom,getLabel } from '../../util/convert';
import * as _ from '../../util/public/common';

export default class Main extends React.Component{
    render(){
        const { msg,haveLocked } = this.props;
        const bgcolor = haveLocked ? "#FFFCD8" : "#E7F9FF";
        const icon = haveLocked ? "icon-coms-locking" : "icon-coms-Prompt";
        return (
            <div className="wf-lock-msg" style={{backgroundColor:bgcolor}}>
                <div className="wf-lock-msg-content">
                    <i className={icon} />
                    <span dangerouslySetInnerHTML={{__html:msg}} />
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ../src4js/pc4mobx/workflowForm/components/topPropmpt/EditLock.js